<template>
  <div>
    <h2 class="text-sm font-semibold text-gray-800">{{ title }}</h2>
    <p v-if="description" class="mt-0.5 text-xs text-gray-500">{{ description }}</p>
    <table class="mt-2 w-full text-left text-sm">
      <thead class="border-b border-gray-200 text-xs uppercase text-gray-500">
        <tr>
          <th class="py-2 pr-4">Champ</th>
          <th class="py-2 pr-4">Verdict</th>
          <th class="py-2 pr-4">Comparaison</th>
          <th class="py-2">Raison</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="check in checks" :key="check.field" class="border-b border-gray-100">
          <td class="py-2 pr-4 font-medium text-gray-700">{{ check.label }}</td>
          <td class="py-2 pr-4">
            <span
              :class="badgeClassFor(check.verdict)"
              class="inline-flex items-center rounded-full px-2 py-0.5 text-xs font-bold"
            >
              {{ verdictLabel(t, check.verdict) }}
            </span>
          </td>
          <td class="py-2 pr-4 text-gray-700">
            <template v-if="check.verdict === 'PASS'">
              <span>{{ check.extractedValue || "—" }}</span>
            </template>
            <template v-else>
              <div class="flex flex-col gap-0.5">
                <span>
                  <span class="font-semibold text-gray-500">Pièce :</span>
                  {{ check.extractedValue || "—" }}
                </span>
                <span>
                  <span class="font-semibold text-gray-500">Attendu :</span>
                  {{ check.expectedValue || "—" }}
                </span>
              </div>
            </template>
          </td>
          <td class="py-2 text-gray-600">{{ check.reason }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { useI18n } from "vue-i18n";
import { verdictLabel, badgeClassFor } from "@/components/claim/details/idCardAnalysisFormatter";

export default {
  name: "VerificationTable",
  setup() {
    const { t } = useI18n();
    return { t };
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: null,
    },
    checks: {
      type: Array,
      required: true,
    },
  },
  methods: {
    verdictLabel,
    badgeClassFor,
  },
};
</script>
